export const options = [
  [
    {
      comment_required: true,
      index: 0,
      is_completion: false,
      is_na: false,
      cost: null,
      name: "Yes Issue",
    },
    {
      comment_required: false,
      index: 1,
      is_completion: true,
      is_na: false,
      cost: null,
      name: "No Issue",
    },
  ],
  [
    {
      comment_required: false,
      index: 0,
      is_completion: true,
      is_na: false,
      cost: null,
      name: "Clean",
    },
    {
      comment_required: true,
      index: 1,
      is_completion: false,
      is_na: false,
      cost: null,
      name: "Dirty",
    },
  ],
  [
    {
      comment_required: false,
      index: 0,
      is_completion: true,
      is_na: false,
      cost: null,
      name: "Good",
    },
    {
      comment_required: true,
      index: 1,
      is_completion: false,
      is_na: false,
      cost: null,
      name: "Replace",
    },
    {
      comment_required: false,
      index: 2,
      is_completion: false,
      is_na: true,
      name: "N/A",
    },
  ],
  [
    {
      comment_required: false,
      index: 0,
      is_completion: true,
      is_na: false,
      cost: null,
      name: "Good",
    },
    {
      comment_required: true,
      index: 1,
      is_completion: false,
      is_na: false,
      cost: null,
      name: "Dirty",
    },
    {
      comment_required: true,
      index: 2,
      is_completion: false,
      is_na: false,
      cost: null,
      name: "Repair",
    },
    {
      comment_required: false,
      index: 3,
      is_completion: false,
      is_na: true,
      name: "N/A",
    },
  ],
  [
    {
      comment_required: false,
      index: 0,
      is_completion: true,
      is_na: false,
      cost: null,
      name: "Good",
    },
    {
      comment_required: true,
      index: 1,
      is_completion: false,
      is_na: false,
      cost: null,
      name: "Dirty",
    },
    {
      comment_required: true,
      index: 2,
      is_completion: false,
      is_na: false,
      cost: null,
      name: "Repair",
    },
    {
      comment_required: true,
      index: 3,
      is_completion: false,
      is_na: false,
      cost: null,
      name: "Replace",
    },
    {
      comment_required: false,
      index: 4,
      is_completion: false,
      is_na: true,
      name: "N/A",
    },
  ],
  [
    {
      comment_required: false,
      index: 0,
      is_completion: true,
      is_na: false,
      cost: null,
      name: "Good",
    },
    {
      comment_required: true,
      index: 1,
      is_completion: false,
      is_na: false,
      cost: null,
      name: "Repair",
    },
    {
      comment_required: true,
      index: 2,
      is_completion: false,
      is_na: false,
      cost: null,
      name: "Replace",
    },
    {
      comment_required: false,
      index: 3,
      is_completion: false,
      is_na: true,
      name: "N/A",
    },
  ],
  [
    {
      comment_required: false,
      index: 0,
      is_completion: true,
      is_na: false,
      cost: null,
      name: "Works",
    },
    {
      comment_required: true,
      index: 1,
      is_completion: false,
      is_na: false,
      cost: null,
      name: "Doesn\'t Work",
    },
    {
      comment_required: true,
      index: 2,
      is_completion: false,
      is_na: false,
      cost: null,
      name: "Replace",
    },
    {
      comment_required: false,
      index: 3,
      is_completion: true,
      is_na: true,
      name: "N/A",
    },
  ]
]

export const customOptions = [
  {
    name: "Add text",
    display_value: "Text",
    input_type: "text",
    is_custom: true,
    comment_required: false,
    index: 1,
    is_completion: false,
    is_na: false
  }
]